export default __webpack_public_path__ + "static/media/IMG_2179-3_x3.3000fb13.jpg";